export default __webpack_public_path__ + "static/media/DO.b1663040.ico";